'use client';

import React, { createContext, useContext, PropsWithChildren } from 'react';
import type { CheckHintContext } from '@puzzlio/core';

/**
 * Distributes the check/hint feedback surface (board messages, hint box, and the Check/Hint actions)
 * to the game UI. Deliberately game-agnostic: the value is a core CheckHintContext, so components
 * consume feedback without knowing the game. The value is produced by a per-game check/hint store in
 * the app; this provider just makes it available via context.
 */
const Context = createContext<CheckHintContext | null>(null);

export function CheckHintProvider({ value, children }: PropsWithChildren<{ value: CheckHintContext }>) {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useCheckHint(): CheckHintContext {
  const context = useContext(Context);
  if (!context) {
    throw new Error('useCheckHint must be used within a CheckHintProvider');
  }
  return context;
}
